import type { PublicSlotKey } from '@/apilib';
import type { PreviewerApi } from './previewerApi';

export const PreviewerApiKey: PublicSlotKey<PreviewerApi> = {
  name: 'PreviewerApi',
  public: true,
};
